module.exports = __webpack_public_path__ + "img/logo.7f96be4b.svg";